import {
    ColumnDef,
} from '@tanstack/react-table';
import { IFormattedCashFlowPeriod } from 'views/ProFormaTable/types';
import RenderIf from 'components/RenderIf/RenderIf';
import { IncomeCalculationType } from 'constants/proForma';
import DataCenterFloorAllocationsTable from './DataCenterFloorAllocationsTable/DataCenterFloorAllocationsTable';
import DataCenterTenantsTable from './DataCenterTenantsTable/DataCenterTenantsTable';
import DataCenterTenantsRecoveryTable from './DataCenterTenantsRecoveryTable/DataCenterTenantsRecoveryTable';
import OtherIncomeTable from '../commonTables/OtherIncomeTable/OtherIncomeTable';
import TotalPotentialIncomeTable from '../commonTables/TotalPotentialIncomeTable/TotalPotentialIncomeTable';
import IncomeAdjustmentsTable from '../commonTables/IncomeAdjustmentsTable/IncomeAdjustmentsTable';
import EstimateRecoveryTable from '../commonTables/EstimateRecoveryTable/EstimateRecoveryTable';
import { useProFormaSocketContext } from '../../../socketContext/ProFormaSocketProvider';

export interface IDataCenterIncomeProps {
    operationBeginIndex: number;
    baseCashFlowColumns: ColumnDef<any>[];
    monthlyPeriodOptions: IFormattedCashFlowPeriod[];
}

const DataCenterIncome = ({
    operationBeginIndex,
    baseCashFlowColumns,
    monthlyPeriodOptions,
}: IDataCenterIncomeProps) => {
    const { operatingInfo } = useProFormaSocketContext();

    return (
        <>
            <RenderIf isTrue={operatingInfo.incomeCalculationType === IncomeCalculationType.TENANTS}>
                <DataCenterTenantsTable
                    operationBeginIndex={operationBeginIndex}
                    baseCashFlowColumns={baseCashFlowColumns}
                    monthlyPeriodOptions={monthlyPeriodOptions}
                />
                <DataCenterTenantsRecoveryTable
                    operationBeginIndex={operationBeginIndex}
                    baseCashFlowColumns={baseCashFlowColumns}
                    monthlyPeriodOptions={monthlyPeriodOptions}
                />
            </RenderIf>
            <RenderIf isTrue={operatingInfo.incomeCalculationType !== IncomeCalculationType.TENANTS}>
                <DataCenterFloorAllocationsTable
                    operationBeginIndex={operationBeginIndex}
                    baseCashFlowColumns={baseCashFlowColumns}
                />
                <EstimateRecoveryTable
                    operationBeginIndex={operationBeginIndex}
                    baseCashFlowColumns={baseCashFlowColumns}
                />
            </RenderIf>
            <OtherIncomeTable
                operationBeginIndex={operationBeginIndex}
                baseCashFlowColumns={baseCashFlowColumns}
                monthlyPeriodOptions={monthlyPeriodOptions}
            />
            <TotalPotentialIncomeTable
                operationBeginIndex={operationBeginIndex}
                baseCashFlowColumns={baseCashFlowColumns}
            />
            <IncomeAdjustmentsTable
                operationBeginIndex={operationBeginIndex}
                baseCashFlowColumns={baseCashFlowColumns}
            />
        </>
    );
};

export default DataCenterIncome;
